export const VENDOR_PAYMENT_DETAILS_STEP = {
  INITAL: 1,
  CURRENCY: 2,
  PAYMENT_METHOD: 3,
} as const;
